import {Component, Prop, Vue} from "vue-property-decorator";
import iconClose from '~/assets/inline-svg/icon_close.svg?inline';
import {Icon, icons} from "~/components/icon";

@Component
class TextFilter extends Vue {

  @Prop({type:String, default:""}) value:string;
  @Prop({ type: String, required: true  }) placeholder:string;

  handleInput(e){
    this.$emit("input", e.target.value);
  }

  render() {
    return (
      <div class="text-filter">
        <Icon icon={icons.search} />
        <input
          type="text"
          onInput={this.handleInput}
          value={this.value}
          placeholder={this.placeholder}
        />

        {this.value.length > 0 && (
          <span
            onClick={() => this.$emit("input", "")}
            class="btn--close close-icon"
            domPropsInnerHTML={iconClose}
          />
        )}

      </div>
    );
  }
}

export {TextFilter};

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-10b3293c/text-filter.tsx" });